import { render, staticRenderFns } from "./FacilityCard.vue?vue&type=template&id=08cd1ec2"
import script from "./FacilityCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FacilityCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports